/*
 * Public API Surface of ngx-lib/images-filmstrip
 */
export * from './images-filmstrip.module';
export * from './images-filmstrip.component';
